import { OrderProduct } from '../types/order';

/**
 * Order category / subcategory slugs (Settings → Orders). Must match `order_categories.slug`
 * and `order_subcategories.slug` for Virtual Machine → Vultr plans.
 * (Category name “Virtual Machine” often slugifies to `virtual_machine`, not `virtual-machine`.)
 */
export const VM_ORDER_CATEGORY_SLUG = 'virtual_machine';
export const VM_ORDER_SUBCATEGORY_SLUG = 'vultr';

/** Treat this field as VM Plan (product picker) when editing Virtual Machine services. */
export function isVmPlanServiceField(fieldKey: string, label?: string): boolean {
  const k = (fieldKey || '').toLowerCase().trim();
  const lab = (label || '').trim().toLowerCase();
  if (['vm_plan', 'vmplan', 'vm_plan_name'].includes(k)) return true;
  if (lab === 'vm plan') return true;
  if (k === 'plan' && lab.includes('vm')) return true;
  return false;
}

/** Map stored id or legacy product name to display name; pass through unknown values. */
export function resolveVmPlanDisplay(stored: string, products: OrderProduct[]): string {
  const s = (stored || '').trim();
  if (!s || s === '—') return s;
  const byId = products.find((p) => p.id === s);
  if (byId) return byId.name;
  const byName = products.find((p) => p.name === s);
  if (byName) return byName.name;
  return s;
}

/** Value for MUI Select: prefer product id; normalize legacy name to id when possible. */
export function vmPlanSelectValue(raw: string, products: OrderProduct[]): string {
  const s = (raw || '').trim();
  if (!s) return '';
  if (products.some((p) => p.id === s)) return s;
  const byName = products.find((p) => p.name === s);
  return byName ? byName.id : s;
}
